module.exports = __webpack_public_path__ + "static/media/slide (1).dfc5fbf9.jpg";